export default function EditorDashboard() {
  return <h1>Editor Dashboard</h1>;
}
